<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    export let label: string
    export let css: string
    export let text: string
    export let values: { [key: string]: any }
    values = values || null
    export let dependsOn: OfferAssistantDependsOnRule[]

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true

    $: if (values && dependsOn) {
        displayComponent = ruleEngine.resolve(dependsOn, values)
    }
</script>

{#if displayComponent}
    <div class="info-text {css ? css : ''}">
        {#if label}
            <label for="">{label}</label>
        {/if}
        {#if text}
            <p>{@html text}</p>
        {/if}
    </div>
{/if}
